<div class="logo-container">
  <img alt="KPMG Rubix Logo" src="../../../assets/login-logos.png">
</div>

@if (isHandlingRedirect()) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <div class="form-container">
    <app-login-form></app-login-form>
  </div>
}
